<h2>{{data.title}}</h2>

<p>{{data.text}}</p>

<div class="btn_action">
  <button class="confirm" (click)="dialogRef.close()"> Fermer</button>
</div>
